import { MdOutlineDriveFileMove } from "react-icons/md";
import React from "react"
import { BaseIcon } from "./BaseIcon"

interface Props {
	color?: string
	className?: string
}

export const IconMove = ({color, className}: Props) => {
	return (
		<BaseIcon color={color} className={className}>
			<MdOutlineDriveFileMove/>
		</BaseIcon>
	)
}
